<template>
  <div class="point-select-modal">
    <div class="point-config">
      <div class="point-config-header">
        <span class="point-config-title">
<!--          <span class="red">*</span>-->
          绑定巡检点位（拖拽上下调整顺序）</span>
        <el-button
          type="primary"
          size="small"
          icon="el-icon-plus"
          @click="openPointModal"
          :disabled="disabled"
        >
          从点位库选择点位
        </el-button>
      </div>
      <div class="point-list" v-if="selectedPoints.length > 0">
        <div
          class="point-item"
          v-for="(item, index) in selectedPoints"
          :key="item.id || item.pointCode"
          :draggable="!disabled"
          :class="{ 'dragging': dragIndex === index, 'drag-over': dragOverIndex === index }"
          @dragstart="onDragStart(index, $event)"
          @dragover.prevent="onDragOver(index, $event)"
          @dragleave="onDragLeave"
          @drop="onDrop(index, $event)"
          @dragend="onDragEnd"
        >
          <span class="drag-handle">⋮⋮</span>
          <span>{{ item.pointName }}（{{ item.pointCode }}）</span>
          <div class="point-item-op">
            <el-button
              type="text"
              size="mini"
              @click="movePointUp(index)"
              :disabled="index === 0 || disabled"
            >上移</el-button>
            <el-button
              type="text"
              size="mini"
              @click="movePointDown(index)"
              :disabled="index === selectedPoints.length - 1 || disabled"
            >下移</el-button>
            <el-button
              type="text"
              size="mini"
              style="color: #f53f3f"
              @click="removePoint(index)"
              :disabled="disabled"
            >移除</el-button>
          </div>
        </div>
      </div>
      <div v-else class="point-empty">暂未选择点位，请点击"从点位库选择点位"按钮添加</div>
    </div>

    <ml-dialog
      width="800px"
      ref="pointModalRef"
      title="点位选择库"
      @click-submit="confirmSelectPoint"
    >
      <template #body>
        <div class="point-modal-body">
          <ml-form inline labelWidth="100px" :model="searchData">
            <ml-input
              prop="keyword"
              placeholder="请输入点位名称"
              label="点位名称:"
              v-model="searchData.keyword"
              style="margin-bottom: 0;width: 240px;"
            />
            <ml-select
              prop="pointType"
              placeholder="请选择分类"
              :options="pointTypeOptions"
              label="分类:"
              keyName="value"
              labelName="label"
              valueName="value"
              v-model="searchData.pointType"
              style="margin-bottom: 0;width: 240px;"
            />
            <ml-button
              :style="{ 'margin-bottom': 0 }"
              submitText="搜索"
              submitIcon="el-icon-search"
              cancelText="重置"
              cancelIcon="el-icon-refresh"
              cancelType="danger"
              @click-cancel="handleReset"
              @click-submit="handleSearch"
            />
          </ml-form>
          <el-table
            :data="pointTabberData.data"
            style="width: 100%"
            :height="400"
            @select-all="handleSelectAllPoint"
            @select="handleSelectPoint"
            row-key="id"
            ref="pointTableRef"
          >
            <el-table-column type="selection" width="55" />
            <el-table-column align="center" label="点位编号" prop="pointCode" min-width="20%" />
            <el-table-column align="center" label="点位名称" prop="pointName" min-width="25%" />
            <el-table-column align="center" label="分类" prop="pointType" min-width="20%">
              <template #default="scope">
                {{ pointTypeMap[scope.row.pointType] || scope.row.pointType }}
              </template>
            </el-table-column>
            <el-table-column align="center" label="所属阿米巴" prop="companyName" min-width="25%" />
          </el-table>
          <ml-pagination
            :total="pointTabberData.total"
            :page="pointTabberData.page"
            v-model="pointTabberData.page"
            :size="pointTabberData.size"
            @current-change="pointCurrentChange"
            @size-change="pointSizeChange"
          />
        </div>
      </template>
    </ml-dialog>
  </div>
</template>

<script>
import { computed, nextTick, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import { getTabberData } from '@/utils'

const pointTypeMap = {
  '1': '硬件设备',
  '2': '建筑物',
  '3': '地理位置'
}

export default {
  name: 'PointSelectModal',
  props: {
    modelValue: {
      type: Array,
      default: () => []
    },
    disabled: {
      type: Boolean,
      default: false
    },
    companyId: {
      type: String,
      default: ''
    },
    projectId: {
      type: String,
      default: ''
    }
  },
  emits: ['update:modelValue'],
  setup(props, { emit }) {
    const { dispatch } = useStore()

    const selectedPoints = ref([])
    const tempSelectedPoints = ref([])
    const dragIndex = ref(-1)
    const dragOverIndex = ref(-1)
    const searchData = reactive({
      keyword: '',
      pointType: ''
    })
    const pointTypeOptions = computed(() => {
      return Object.entries(pointTypeMap).map(([value, label]) => ({
        value,
        label
      }))
    })
    const pointModalRef = ref()
    const pointTableRef = ref()
    const pointTabberData = reactive({
      data: [],
      total: 0,
      page: 1,
      size: 10
    })

    watch(() => props.modelValue, (newVal) => {
      selectedPoints.value = [...(newVal || [])]
    }, { immediate: true })

    const emitUpdate = () => {
      const list = selectedPoints.value.map((item, index) => ({
        id: item.id,
        pointCode: item.pointCode,
        pointName: item.pointName,
        sort: index + 1
      }))
      emit('update:modelValue', list)
    }

    const getPointTableData = async (
      params = {
        pageIndex: pointTabberData.page,
        pageSize: pointTabberData.size,
        projectId: props.projectId,
        companyId: props.companyId,
        dataStatus:"1",
        keyword: searchData.keyword,
        pointType: searchData.pointType
      }
    ) => {
      const { data } = await getTabberData(
        dispatch,
        'fetchGetInspectionPointPage',
        params
      )
      pointTabberData.data = data.records || []
      pointTabberData.total = data.total || 0
      if (tempSelectedPoints.value.length > 0) {
        pointTabberData.data.forEach(row => {
          if (tempSelectedPoints.value.some(p => p.id === row.id)) {
            nextTick(() => {
              pointTableRef.value.toggleRowSelection(row, true)
            })
          }
        })
      }
    }

    const pointCurrentChange = page => {
      pointTabberData.page = page
      getPointTableData()
    }
    const pointSizeChange = size => {
      pointTabberData.size = size
      pointTabberData.page = 1
      getPointTableData()
    }

    const handleSearch = () => {
      pointTabberData.page = 1
      getPointTableData()
    }

    const handleReset = () => {
      searchData.keyword = ''
      searchData.pointType = ''
      pointTabberData.page = 1
      getPointTableData()
    }

    const openPointModal = () => {
      tempSelectedPoints.value = [...selectedPoints.value]
      searchData.keyword = ''
      searchData.pointType = ''
      pointTabberData.page = 1
      pointTabberData.size = 10
      getPointTableData()
      pointModalRef.value.showDialog = true
    }

    const closePointModal = () => {
      pointModalRef.value.showDialog = false
    }

    const handleSelectAllPoint = selection => {
      const currentPageIds = pointTabberData.data.map(item => item.id)
      const otherPageSelected = tempSelectedPoints.value.filter(
        p => !currentPageIds.includes(p.id)
      )
      tempSelectedPoints.value = [...otherPageSelected, ...selection]
    }

    const handleSelectPoint = (selection, row) => {
      const isSelected = selection.some(item => item.id === row.id)
      if (isSelected) {
        if (!tempSelectedPoints.value.some(p => p.id === row.id)) {
          tempSelectedPoints.value.push(row)
        }
      } else {
        tempSelectedPoints.value = tempSelectedPoints.value.filter(p => p.id !== row.id)
      }
    }

    const confirmSelectPoint = () => {
      selectedPoints.value = [...tempSelectedPoints.value]
      emitUpdate()
      closePointModal()
    }

    const movePointUp = index => {
      if (index <= 0) return
      const arr = [...selectedPoints.value]
      ;[arr[index], arr[index - 1]] = [arr[index - 1], arr[index]]
      selectedPoints.value = arr
      emitUpdate()
    }

    const movePointDown = index => {
      if (index >= selectedPoints.value.length - 1) return
      const arr = [...selectedPoints.value]
      ;[arr[index], arr[index + 1]] = [arr[index + 1], arr[index]]
      selectedPoints.value = arr
      emitUpdate()
    }

    const removePoint = index => {
      const arr = [...selectedPoints.value]
      arr.splice(index, 1)
      selectedPoints.value = arr
      emitUpdate()
    }

    const onDragStart = (index, event) => {
      if (props.disabled) return
      dragIndex.value = index
      event.dataTransfer.effectAllowed = 'move'
      event.dataTransfer.setData('text/plain', index)
    }

    const onDragOver = (index, event) => {
      if (props.disabled || dragIndex.value === -1) return
      event.preventDefault()
      dragOverIndex.value = index
    }

    const onDragLeave = () => {
      dragOverIndex.value = -1
    }

    const onDrop = (index, event) => {
      event.preventDefault()
      if (props.disabled || dragIndex.value === -1 || dragIndex.value === index) {
        dragIndex.value = -1
        dragOverIndex.value = -1
        return
      }
      const arr = [...selectedPoints.value]
      const [movedItem] = arr.splice(dragIndex.value, 1)
      arr.splice(index, 0, movedItem)
      selectedPoints.value = arr
      emitUpdate()
      dragIndex.value = -1
      dragOverIndex.value = -1
    }

    const onDragEnd = () => {
      dragIndex.value = -1
      dragOverIndex.value = -1
    }

    return {
      pointTypeMap,
      pointTypeOptions,
      searchData,
      selectedPoints,
      dragIndex,
      dragOverIndex,
      pointModalRef,
      pointTableRef,
      pointTabberData,
      openPointModal,
      handleSelectAllPoint,
      handleSelectPoint,
      confirmSelectPoint,
      movePointUp,
      movePointDown,
      removePoint,
      onDragStart,
      onDragOver,
      onDragLeave,
      onDrop,
      onDragEnd,
      pointCurrentChange,
      pointSizeChange,
      handleSearch,
      handleReset
    }
  }
}
</script>

<style lang="scss" scoped>
.point-modal-body{
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
.point-select-modal {

  .point-config {
    border: 1px solid #e4e7ed;
    padding: 18px 22px;
    border-radius: 6px;
    background-color: #fcfdff;
    width: 100%;
    .point-config-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 14px;
      .point-config-title {
        font-size: 15px;
        font-weight: 600;
      }
    }
    .point-list {
      min-height: 44px;
      .point-item {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 8px 12px;
        background: #f7f8fa;
        border-radius: 4px;
        margin: 6px 0;
        cursor: grab;
        transition: opacity 0.2s, border-color 0.2s;
        border: 2px solid transparent;
        .drag-handle {
          color: #c0c4cc;
          font-size: 16px;
          margin-right: 8px;
          cursor: grab;
          user-select: none;
          letter-spacing: -2px;
        }
        &.dragging {
          opacity: 0.4;
        }
        &.drag-over {
          border-color: #409eff;
          background: #ecf5ff;
        }
        .point-item-op {
          display: flex;
          gap: 4px;
        }
      }
    }
    .point-empty {
      color: #999;
      font-size: 13px;
      padding: 10px 0;
    }
    .red {
      color: #f53f3f;
    }

  }
  .el-select {
    width: 150px;
  }
}
</style>